import { useContext } from "react";
import { Context } from "../../utils/main-context/MainContext";

import "./space.scss";

const Space = () => {
  const { spaceActive } = useContext(Context);

  return <div className={spaceActive ? "space active" : "space"}></div>;
};

export default Space;
